import { combineReducers } from 'redux'
import GoalManagementContainer from './container/GoalManagementContainer';
import EditGoalManagementContainer from './container/EditGoalManagementContainer';
import DeletedGoalContainer from './container/DeletedGoalContainer';
import SubjectMappingContainer from './container/SubjectMappingContainer';
import SubSubjectMappingContainer from './container/SubSubjectMappingContainer';
import ChapterMappingContainer from './container/ChapterMappingContainer';
import ConceptMappingContainer from './container/ConceptMappingContainer';
import goalManagementReducers from './reducers/goalManagementReducers';

const components = { GoalManagementContainer, EditGoalManagementContainer, SubjectMappingContainer, ChapterMappingContainer, ConceptMappingContainer, SubSubjectMappingContainer,DeletedGoalContainer };


const reducers = combineReducers({
    goalManagement: goalManagementReducers
});

export { components, reducers };